import type { ReactNode } from 'react';
import { TaskItemCard, fillCopy } from '@/features/contribution-kit';
import type { LabelImagesCopy } from '../label-images-copy';

/** The handwritten character to identify, square and centred. */
export function LabelImageCard({
  copy,
  imageUrl,
  imageIndex,
  footer,
}: {
  copy: LabelImagesCopy;
  imageUrl: string;
  imageIndex: number;
  footer?: ReactNode;
}) {
  return (
    <TaskItemCard label={copy.toIdentify} footer={footer}>
      <div className="mx-auto aspect-square w-full max-w-sm overflow-hidden rounded-lg border border-border/60 bg-surface-2">
        <img
          src={imageUrl}
          alt={fillCopy(copy.imageAlt, { index: imageIndex + 1 })}
          data-testid="label-images-image"
          className="h-full w-full object-contain"
        />
      </div>
      <p className="text-center text-sm text-muted-foreground">{copy.question}</p>
    </TaskItemCard>
  );
}
